export default __webpack_public_path__ + "static/backgroundImageMobile-7255d3c9992bdb5d08270b2cb3d45c25.png";